import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

import "./styles/globals.css";
import reportWebVitals from "./reportWebVitals.ts";

// Import Sentry configuration and ErrorBoundary
// import { initSentry, createSentryQueryClient } from "./utils/sentry";
// import { ErrorBoundary } from "./components/ErrorBoundary";

// Initialize Sentry - replace with your actual DSN

// Create the query client with Sentry integration

// Create a new router instance
const router = createRouter({
  routeTree,
  context: {},
  defaultPreload: "intent",
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById("app");
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      {/* <ErrorBoundary> */}
        {/* <QueryClientProvider client={queryClient}> */}
          <RouterProvider router={router} />
          {/* {process.env.NODE_ENV !== "production" && <ReactQueryDevtools />} */}
        {/* </QueryClientProvider> */}
      {/* </ErrorBoundary> */}
    </StrictMode>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
